import { UntypedFormControl } from '@angular/forms';

// todo: in wrong place
export function NoEmptyString(control: UntypedFormControl) {
  let isWhitespace = (control.value || '').trim().length === 0;
  let isValid = !isWhitespace;

  //var str = control.value
  //var the_char = str.charAt(0)
  //
  //if (the_char === " ") {
  //    //alert("first char of the query is space");
  //    return null;
  //}

  return isValid ? null : { whitespace: true };
}
